
import { USIPlayerMonitor } from "@/store/usi";
import { defineComponent } from "vue";

export default defineComponent({
  name: "EngineAnalyticsElement",
  props: {
    name: {
      type: String,
      required: true,
    },
    info: {
      type: USIPlayerMonitor,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
  },
});
